<template>
  <el-menu :default-active="current" theme="dark" :unique-opened="false" style="height:100%">
    <div class="gap"></div>
    <template v-for="(route,index) in menuItems">
      <el-submenu v-if="route.subMenus.length && hasKeyByJurisdiction(route.name)" :index="route.name">
        <span slot="title" class="firstSub">
          <img :src="route.img">{{ route.text }}
        </span>
        <el-menu-item v-for="child in route.subMenus" v-if="hasKeyByJurisdiction(child.menuKey, 1)"
                      @click="clickAction(child,route)" :index="child.menuKey" :key="child.menuKey"
                      style="display: flex;justify-content: space-between">
          <span>{{ child.text }}</span>
        </el-menu-item>
      </el-submenu>
      <el-menu-item v-else-if="hasKeyByJurisdiction(route.name)" :index="route.name" @click="clickAction(route,route)">
        <span slot="title" class="firstSub">
          <img :src="route.img">{{ route.text }}
        </span>
      </el-menu-item>
    </template>

  </el-menu>
</template>
<script>
  export default {
    data() {
      return {
        menuItems: this.cache.fetchMenuItems(),
        show: false,
        // system: this.cache.fetchSystemItems(),
//        jurisdiction: parseInt(this.cache.fetchSystemJurisdiction()),
        jurisdiction: 10,
      }
    },
    computed: {
      current() {
        if (this.$store.state.layout.currentMenuKey) {
          return this.$store.state.layout.currentMenuKey
        } else {
          return 'desktoppush'
        }
      }
    },
    methods: {
      clickAction(item, route) {
        if(item.menuKey === this.$route.name) {
          return
        }
        this.$router.push({name: item.menuKey})
      },

      hasKeyByJurisdiction(key, type) {
        if(this.jurisdiction === 10) return true;
        for (let i = 0, len = this.system.length; i < len; i++) {
          if (this.system[i] === key) {
            return true;
          }
        }
        return false;
      }
    },
  }
</script>
<style lang="scss" type="text/scss" scoped>

  @import "../../style/public";

  $sideNavWidth: 206px;

  .el-menu-item.is-active {
    color: $themeColor;
  }

  .el-menu {
    border-radius: 0;
    overflow-y: auto;
    overflow-x: hidden;
    flex-basis: $sideNavWidth;
    flex-shrink: 0;
  }

  .el-menu-item.is-active {
    background-color: $topDarkColor !important;
    color: white;
  }

  .el-menu-item:hover {
    background-color: $topDarkColor;
    color: white !important;
  }

  .firstSub {
    display: flex;
    align-items: center;
    color: white;
    img {
      margin-right: 15px;
    }
  }

  .el-menu-item {
    text-indent: 12px;
  }

  .badge {
    color: white;
    margin-right: 18px;
  }

  .el-submenu .el-menu-item {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/side-nav.vue